var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLatedelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.921,
    height: 26.943,
    viewBox: "0 0 32.921 26.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Late_delivery",
    "data-name": "Late delivery",
    transform: "translate(-186.464 -192.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M219.384,208.858l-2.493-6.483h-5.485v-6.483H197.891a5.984,5.984,0,1,0-7.929,7.929v7.031h1.5v5.984h3.58a3.237,3.237,0,0,0,6.3,0H209a3.237,3.237,0,0,0,6.3,0h4.079Zm-31.416-10.472a4.488,4.488,0,1,1,1.315,3.173A4.488,4.488,0,0,1,187.968,198.386Zm4.488,5.984h0a5.949,5.949,0,0,0,5.894-6.981h11.559v11.968H191.459V204.28a5.961,5.961,0,0,0,1,.09Zm5.735,13.464a1.745,1.745,0,1,1,1.234-.511A1.745,1.745,0,0,1,198.19,217.834Zm13.962,0a1.746,1.746,0,1,1,1.234-.511A1.745,1.745,0,0,1,212.153,217.834Zm5.735-6.483v3.989H215.3a3.237,3.237,0,0,0-6.3,0h-7.659a3.237,3.237,0,0,0-6.3,0h-2.084v-4.488H211.4v-6.981h4.488l1.995,4.987Z",
    transform: "translate(0)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M254.483,232.1l-1.8-1.346v-2.743h-1V231a.5.5,0,0,0,.2.4l1.995,1.5Z",
    transform: "translate(-59.733 -32.613)",
    fill: "#ff7200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatedelivery);
export default __webpack_public_path__ + "static/media/Latedelivery.e2cada6ebf8fb8869df99e8c7dc12e79.svg";
export { ForwardRef as ReactComponent };